












import { computed, defineComponent, PropType } from '@vue/composition-api';
import { TaskItem } from '@/types/task';
import { i18n } from '@/i18n';

export default defineComponent({
  name: 'TaskProgress',
  props: {
    taskInfo: {
      type: Object as PropType<TaskItem>,
      required: true,
    },
  },
  setup(props) {
    /** 是否完成 */
    const isDone = computed(() => {
      const { finishCount, maxTimesPerStage } = props.taskInfo;
      return finishCount >= maxTimesPerStage;
    });
    /** 进度 */
    const progress = computed(() => {
      const { finishCount, maxTimesPerStage, prizeCountPerTime } = props.taskInfo;
      const finished = finishCount * prizeCountPerTime;
      const max = maxTimesPerStage * prizeCountPerTime;
      return i18n('已得{{finished}}/{{max}}', { finished, max });
    });
    const svgIconName = computed(() => (props.taskInfo.type === 'limit' ? 'task-done-orange' : 'task-done'));
    return {
      isDone,
      svgIconName,
      progress,
    };
  },
});
